<template>
  <div id="home">
    <my-header></my-header>
    <div class="pd20">
      <h3>{{'Active new password via email'|translate}}</h3>
      <loading v-if="loading" class="mt10 text-center" :text="'Please wait'|translate"></loading>
      <p
        v-if="!loading"
        class="alert mt20"
        v-bind:class="{ 'alert-success': success,'alert-warning': !success }"
      >{{message|translate}}</p>
    </div>
    <!-- end pd20 -->
  </div>
</template>

<script>
// http://farmbook.com/API/listProduct
import Utils from "@/helpers/utils";
import MyHeader from "@/components/Layout/Header";
import Loading from "@/components/elements/Loading";

export default {
  name: "ActiveNewPassword",
  components: {
    MyHeader,
    Loading
  },
  data() {
    return {
      loading: true,
      success: true,
      message: ""
    };
  },
  methods: {
    activeNewPassword() {
      Utils.request(this, true)
        .post(`/activeNewPassword/`, { hash: this.hash })
        .then(response => {
          this.loading = false;
          let data = response.data;
          this.success = data.status == "ok";
          this.message = data.data;
        })
        .catch(error => {
          Utils.showErrorMessage(this, error.response);
        });
    }
  },
  mounted() {
    this.hash = this.$route.params.hash;
    this.activeNewPassword();
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Profile/ActiveNewPassword.vue